/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiRequestManageTicketTagsSearch } from '../../models/api-request-manage-ticket-tags-search';
import { ApiResponsePageManageTicketTags } from '../../models/api-response-page-manage-ticket-tags';

export interface SearchTags$Params {
      body: ApiRequestManageTicketTagsSearch
}

export function searchTags(http: HttpClient, rootUrl: string, params: SearchTags$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePageManageTicketTags>> {
  const rb = new RequestBuilder(rootUrl, searchTags.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePageManageTicketTags>;
    })
  );
}

searchTags.PATH = '/v1/api/ui/manage-ticket-tags/search';
